<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-8 col-8">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("bc_platform_connect") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

				<div class="col-lg-2 col-2 text-right">
					<base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true, enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S' }"
                                        class="form-control datepicker"
                                        v-model="time_from"
                                    >
                                    </flat-picker>
                                </base-input>

								<!-- Time From -->
                </div>

				<div class="col-lg-2 col-2 text-right">
					<base-input>
						<flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true, enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S' }"
                                        class="form-control datepicker"
                                        v-model="time_to"
                                    >
                                    </flat-picker>
					</base-input>
					<!-- Time To -->
				</div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
			<div class="row">
				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Tiktok</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/tiktok.png" width="150px" height="150px">
					</div>
				  </div>

                    <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="TiktokSeller" label="Seller"  placeholder="Seller" value-key="id">
									<el-option v-for="option in tableTiktokeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('tiktok')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('tiktok')"> Token </base-button>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('tiktok')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('tiktok')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('tiktok')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('tiktok')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Lazada</h5>
				   <div class="row">
					<div class="col-md-12"> <img src="/img/lazada.png" width="150px" height="150px"> </div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="LazadaSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableLazadaSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                   <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('lazada')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('lazada')"> Token </base-button>
						</div>
					</div>

                   <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('lazada')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('lazada')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('lazada')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('lazada')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Shopee</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/shopee.png"  width="150px" height="150px">
					</div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="ShopeeSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableShopeeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('shopee')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('shopee')"> Token </base-button>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('shopee')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('shopee')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('shopee')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('shopee')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">Line</h5>
					  <div class="row">
						<div class="col-md-12">
							<img src="/img/linemyshop.png"  width="150px" height="150px">
						</div>
					  </div>

					  <div class="row mt-3 px-3">
							<div class="col-md-12">
								<base-input placeholder="Seller">
									<el-select v-model="LineShopSeller" label="Seller"  placeholder="Seller">
										<el-option v-for="option in tableLineShopSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
									</el-select>
								</base-input>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('line')"> Sync Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('line')"> Sync Product </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('line')">Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('line')">Product </base-button>
							</div>
						</div>

					</card>
					</div>

				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">Pancake</h5>
					  <div class="row">
						<div class="col-md-12">
							<img src="/img/pancake.webp"  width="150px" height="150px">
						</div>
					  </div>

					  <div class="row mt-3 px-3">
							<div class="col-md-12">
								<base-input placeholder="Seller">
									<el-select v-model="PancakeSeller" label="Seller"  placeholder="Seller">
										<el-option v-for="option in tablePancakeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
									</el-select>
								</base-input>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('pancake')"> Sync Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('pancake')"> Sync Product </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('pancake')">Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('pancake')">Product </base-button>
							</div>
						</div>

					</card>
					</div>
			</div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/TiktokclientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            // tableData: "Tiktok/getOrders",
            tableSeller: "Platform/getSellers"
        }),
		tableTiktokeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 2
			})
		},
		tableLazadaSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 4
			})
		},
		tableShopeeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 3
			})
		},
		tableLineShopSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 5
			})
		},
		tablePancakeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 8
			})
		},
        tableColumns: function() {
            return [
                {
                    prop: "ProductName",
                    label: this.$t("wms.product"),
                    minWidth: 90,
                    sortable: true
                },

                {
                    prop: "StorageName",
                    label: this.$t("wms.storage"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "Balance",
                    label: this.$t("wms.balance"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "OverallAmount",
                    label: this.$t("wms.overall_amount"),
                    minWidth: 90,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
			time_from: "",
			time_to: "",
            propsToSearch: ["Number", "Email"],
			productLoading:false,
			orderLoading:false,
            selectedRows: [],
            SearchKeyword: "",
            showAddModal: false,
            showInOutModal: false,
            status: 0,
            startDate: "",
            endDate: "",
			TiktokSeller:null,
			LazadaSeller:null,
			ShopeeSeller:null,
			LineShopSeller:null,
			PancakeSeller:null,
            md: {
                InventoryID: 0,
                ProductID: "-",
                StorageID: "-",
                Note: "",
                Quantity: "0",
                Cost: 0
            },
            inOut: {
                InventoryID: 0,
                ProductID: 0,
                StorageID: 0,
                Note: "",
                Quantity: 0,
                Cost: 0,
                Action: ""
            },
            rowEdit: {
                ID: 0,
                Number: ""
            },

            OrderStatus: [
                { ID: 0, Name: "All" },
                { ID: 100, Name: "Unpaid" },
                { ID: 111, Name: "AwaitingShipment" },
                { ID: 112, Name: "AwaitingCollection" },
                { ID: 114, Name: "PartiallyShipping" },
                { ID: 121, Name: "InTransit" },
                { ID: 122, Name: "Delivered" },
                { ID: 130, Name: "Completed" },
                { ID: 140, Name: "Cancelled" }
            ],
			PlatformTable: [
				{id:1,name:"madamefin"},
				{id:2,name:"tiktok"},
				{id:3,name:"shopee"},
				{id:4,name:"lazada"},
				{id:5,name:"line"},
				{id:6,name:"pancake"},

			]
        };
    },
    watch: {
		time_from() {
			this.validateDateRange();
		},
		time_to() {
			this.validateDateRange();
		}
	},
    mounted() {
		this.time_from = moment().format('YYYY-MM-DD 00:00:00');
		this.time_to = moment().format('YYYY-MM-DD 23:59:59');
		this.SellerList()

	},
    methods: {
        ...mapActions({
            // InventoryIn: "Inventory/InventoryIn",
            // InventoryOut: "Inventory/InventoryOut",
            // InventoryDelete: "Inventory/InventoryDelete",
            // listData: "Tiktok/GetOrderList",
            // getShippingDocument: "Tiktok/GetShippingDocument",
            syncProduct: "Platform/SyncProduct",
            syncOrder: "Platform/SyncOrder",
            syncProductV2: "Platform/SyncProductV2",
            syncOrderV2: "Platform/SyncOrderV2",
            ConnectPlatform: "Platform/ConnectPlatform",
            SellerList: "Platform/listSeller",
			RefreshToken: "Platform/RefreshToken",
        }),
		validateDateRange() {
			if (!this.time_from || !this.time_to) return true;
			
			const fromDate = moment(this.time_from, 'YYYY-MM-DD HH:mm:ss');
			const toDate = moment(this.time_to, 'YYYY-MM-DD HH:mm:ss');
			
			if (fromDate.isAfter(toDate)) {
				swal.fire({
					title: "เวลาเริ่มต้นต้องน้อยกว่าเวลาสิ้นสุด",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return false;
			}
			
			const daysDiff = toDate.diff(fromDate, 'days', true);
			if (daysDiff > 2) {
				swal.fire({
					title: "ช่วงเวลาต้องไม่เกิน 2 วัน",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return false;
			}
			
			return true;
		},
		GetPlatformID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name == platform)
				{
					platform_id = v.id
				}
			})

			return platform_id
		},

		handleOrder(platform){
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
		},
		handleProduct(platform){
				this.$router.push({ path: `/admin/product/${platform}` });

		},

		handleSyncOrder(platform){
			if (!this.validateDateRange()) {
				return;
			}

			let params = {
				platform : platform,
				open_id : "",
				shop_id : "",
				shop_name : "",
                time_from : this.time_from,
                time_to : this.time_to,
			}

			try {
				switch (platform)  {
					case "tiktok" :
					 	params.open_id = this.TiktokSeller.open_id;
					 	params.shop_id = this.TiktokSeller.shop_id;
					 	params.shop_name = this.TiktokSeller.shop_name;
					 	params.shop_cipher = this.TiktokSeller.shop_cipher;

					break
					case "shopee" :
						params.open_id = this.ShopeeSeller.open_id;
					 	params.shop_id = this.ShopeeSeller.shop_id;
					 	params.shop_name = this.ShopeeSeller.shop_name;
					 	params.shop_cipher = this.ShopeeSeller.shop_cipher;
					break
					case "lazada" :
						params.open_id = this.LazadaSeller.open_id;
					 	params.shop_id = this.LazadaSeller.shop_id;
					 	params.shop_name = this.LazadaSeller.shop_name;
					 	params.shop_cipher = this.LazadaSeller.shop_cipher;
						break
					case "line" :
						params.open_id = this.LineShopSeller.open_id;
					 	params.shop_id = this.LineShopSeller.shop_id;
					 	params.shop_name = this.LineShopSeller.shop_name;
					 	params.shop_cipher = this.LineShopSeller.shop_cipher;
						break
					case "pancake" :
						params.open_id = this.PancakeSeller.open_id;
					 	params.shop_id = this.PancakeSeller.shop_id;
					 	params.shop_name = this.PancakeSeller.shop_name;
					 	params.shop_cipher = this.PancakeSeller.shop_cipher;
						break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			this.syncOrderV2(params).then(resp=>{
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
			}).catch(err=>{

				console.log("error",err)
				this.orderLoading = false
				swal.fire({
                    title: this.$t(err.response.data),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			})
		},
		handleRefreshToken(platform){
			let params = {
				platform : platform,
				shop_id : "",
				shop_cipher : "",
				shop_name : ""	
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; params.shop_cipher = this.TiktokSeller.shop_cipher; params.shop_name = this.TiktokSeller.shop_name; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; params.shop_cipher = this.ShopeeSeller.shop_cipher; params.shop_name = this.ShopeeSeller.shop_name; break
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; params.shop_cipher = this.LazadaSeller.shop_cipher; params.shop_name = this.LazadaSeller.shop_name; break
					case "pancake" :params.shop_id = this.PancakeSeller.shop_id; params.shop_cipher = this.PancakeSeller.shop_cipher; params.shop_name = this.PancakeSeller.shop_name; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			if (params.shop_id == "") {
				swal.fire({
					title: "กรุณาเลือก Seller",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			this.RefreshToken(params).then(resp=>{
				swal.fire({
					title: "Refresh Token Success",
					text: "",
					icon: "success",
					confirmButtonClass: "btn btn-primary btn-fill",
					buttonsStyling: false
				});


			}).catch(err=>{
				swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			});

		},
		handleSyncProduct(platform){

			let params = {
				platform : platform,
				shop_id : "",
				shop_cipher : "",
				shop_name : "",
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; params.shop_cipher = this.TiktokSeller.shop_cipher; params.shop_name = this.TiktokSeller.shop_name; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; params.shop_cipher = this.ShopeeSeller.shop_cipher; params.shop_name = this.ShopeeSeller.shop_name; break
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; params.shop_cipher = this.LazadaSeller.shop_cipher; params.shop_name = this.LazadaSeller.shop_name; break
					case "line" :params.shop_id = this.LineShopSeller.shop_id; params.shop_cipher = this.LineShopSeller.shop_cipher; params.shop_name = this.LineShopSeller.shop_name; break
					case "pancake" :params.shop_id = this.PancakeSeller.shop_id; params.shop_cipher = this.PancakeSeller.shop_cipher; params.shop_name = this.PancakeSeller.shop_name; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			console.log("params",params)

			this.syncProductV2(params).then(resp=>{

			this.productLoading = false
				this.$router.push({ path: `/admin/product/${platform}` });
			}).catch(err=>{
			this.productLoading = false
				swal.fire({
                    title: $t("err.response.data.Msg"),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

			});
		},
		handleConnect(platform){
			let id = this.GetPlatformID(platform)
			this.ConnectPlatform(id).then(resp=>{
				window.open(resp.data)
			}).catch(err=>{
				console.log(err)
				swal.fire({
                    title: "Can't connect platform",
                    text: err.respone,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
				})
			})

		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
